import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import Modal from '../Modal';
import { api } from '../../utils/upgradesApi';

const NUMBER_FIELDS = [
  ['vat_rate', 'Sazba DPH (%)', '0.01'], ['quote_valid_days', 'Platnost nabídky (dní)', '1'], ['followup_days', 'Připomenout nabídku po (dnech)', '1'],
  ['hourly_rate', 'Hodinová sazba práce (Kč bez DPH)', '0.01'], ['km_rate', 'Cena za km dopravy (Kč bez DPH)', '0.01'],
];
const TEXT_FIELDS = [
  ['base_address', 'Odkud se jezdí (adresa pro výpočet vzdálenosti)', 'Ulice 1, 123 45 Město'],
  ['company_name', 'Firma na nabídce', ''], ['company_address', 'Adresa firmy', ''], ['company_ico', 'IČO', ''], ['company_dic', 'DIČ', ''],
  ['contact_phone', 'Telefon na nabídce', ''], ['contact_email', 'E-mail na nabídce', ''], ['bank_account', 'Bankovní účet na nabídce', ''],
];

// Module settings (admin / manager): rates, VAT, validity of quotes, base address for travel and the supplier block of the quote PDF.
const UpgradeSettingsModal = ({ onClose, onSaved }) => {
  const [form, setForm] = useState(null);
  const [error, setError] = useState('');
  const [warning, setWarning] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { api('/settings').then(setForm).catch((e) => setError(e.message)); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const { id: _id, updated_at: _u, base_lat: _la, base_lng: _lo, ...payload } = form;
      NUMBER_FIELDS.forEach(([k]) => { payload[k] = Number(payload[k]); });
      const saved = await api('/settings', { method: 'PUT', body: payload });
      if (saved._warning) { setWarning(saved._warning); setSaving(false); onSaved?.(); return; }
      onSaved?.();
      onClose();
    } catch (e) {
      setError(e.message);
      setSaving(false);
    }
  };

  return (
    <Modal show onClose={onClose}>
      <div className="dlv dlv-card" role="dialog" aria-modal="true" aria-labelledby="upg-set-title" style={{ width: 'min(680px, calc(100vw - 32px))', maxHeight: '88vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <h2 id="upg-set-title" className="dlv-section-head__title" style={{ fontSize: 18 }}>Nastavení modulu Úpravy</h2>
          <button type="button" className="dlv-iconbtn" style={{ marginLeft: 'auto' }} onClick={onClose} aria-label="Zavřít"><X size={16} /></button>
        </div>
        {!form && !error && <p className="dlv-hint">Načítám…</p>}
        {form && (
          <div className="upg-fields">
            {NUMBER_FIELDS.map(([k, label, step]) => (
              <div key={k}>
                <label className="dlv-label" htmlFor={`set-${k}`}>{label}</label>
                <input id={`set-${k}`} className="dlv-input" type="number" min="0" step={step} value={form[k] ?? ''} onChange={(e) => set(k, e.target.value)} />
              </div>
            ))}
            {TEXT_FIELDS.map(([k, label, placeholder]) => (
              <div key={k} className={k === 'base_address' || k === 'company_address' ? 'full' : ''}>
                <label className="dlv-label" htmlFor={`set-${k}`}>{label}</label>
                <input id={`set-${k}`} className="dlv-input" value={form[k] ?? ''} placeholder={placeholder} maxLength={255} onChange={(e) => set(k, e.target.value)} />
              </div>
            ))}
            <div className="full">
              <label className="dlv-label" htmlFor="set-quote_footer">Text pod nabídkou</label>
              <textarea id="set-quote_footer" className="dlv-input upg-textarea" value={form.quote_footer ?? ''} maxLength={2000} onChange={(e) => set('quote_footer', e.target.value)} />
            </div>
            <p className="dlv-hint full" style={{ margin: 0 }}>Doprava se počítá z přesné polohy zákazníka: vzdušná čára × 1,3, tam a zpět, krát cena za km. Poloha základny se najde na mapě při uložení adresy.</p>
          </div>
        )}
        {error && <p role="alert" className="upg-error">{error}</p>}
        {warning && <p role="status" className="upg-banner">{warning}</p>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
          <button type="button" className="dlv-btn" onClick={onClose}>{warning ? 'Zavřít' : 'Zrušit'}</button>
          {!warning && <button type="button" className="dlv-btn dlv-btn--primary" disabled={!form || saving} onClick={save}>{saving ? 'Ukládám…' : 'Uložit nastavení'}</button>}
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeSettingsModal;
